import { baseApi } from "../redux/baseAPI";

export const TwilioApi = baseApi.injectEndpoints({
  tagTypes: ["TwiliToken"],
  endpoints: (builder) => ({
    getTwilioToken: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_calls/twilio_token.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["TwiliToken"],
    }),
    getCallStatus: builder.query({
        query: (data) => {
          return {
            url: `/twilio/get_call_started_status.json`,
            method: "GET",
            params: { ...data },
          };
        },
        transformResponse: (response, meta, arg) => response.response,
        providesTags: ["TwilioCallStatus"],
    }),
  }),
});

export const {
  useGetTwilioTokenQuery,
  useGetCallStatusQuery
} = TwilioApi;
